import React from "react";
import { Routes, Route } from "react-router-dom";

import {
  SlantedOverlay,
  ClassicOverlay,
  MinimalOverlay,
  MaxOverlay,
  TotalOverlay,
  GTTotalOverlay,
  PollOverlay,
  Poll1v1Overlay,
  GTOverlay,
  Dashboard,
  DashboardList,
  DashboardShows,
  HypeTrain,
  GTGOverlay,
  RewardsOverlay,
  GenericOverlay,
  MilestoneOverlay,
  VerticalOverlay,
  VerticalOverlay3D,
  EventMaxOverlay,
  EventMilestoneOverlay,
  EventList,
  EventListExample,
  TEST,
} from "../../components/overlays";

import GCXOverlay from "../../components/gcx/GCXOverlay";
import GCXNext from "../../components/gcx/GCXNext";
import GCXNextSmall from "../gcx/GCXNextSmall";
const CreateRoutes = () => {
  return (
    <Routes>
      <Route path="/classic/*" element={<ClassicOverlay />} />
      <Route path="/slanted/*" element={<SlantedOverlay />} />
      <Route path="/min/*" element={<MinimalOverlay />} />
      <Route path="/max/*" element={<MaxOverlay />} />
      <Route path="/gt-total/*" element={<GTTotalOverlay />} />
      <Route path="/polls/*" element={<PollOverlay />} />
      <Route path="/polls-1v1/*" element={<Poll1v1Overlay />} />
      <Route path="/hypetrain/*" element={<HypeTrain />} />
      <Route path="/gtg/*" element={<GTGOverlay />} />
      <Route path="/rewards/*" element={<RewardsOverlay />} />
      <Route path="/generic/*" element={<GenericOverlay />} />
      <Route path="/milestones/*" element={<MilestoneOverlay />} />
      <Route path="/vertical-3d/*" element={<VerticalOverlay3D />} />
      <Route path="/vertical/*" element={<VerticalOverlay />} />
      <Route path="/eventlist/*" element={<EventList />} />
      <Route path="/eventlistexample/*" element={<EventListExample />} />
      <Route path="/event-max/*" element={<EventMaxOverlay />} />
      <Route path="/event-max" element={<EventMaxOverlay eventId={166464} />} />
      <Route
        path="/event-milestones"
        element={<EventMilestoneOverlay eventId={166464} />}
      />
      <Route path="/dashboard/*" element={<Dashboard />} />
      <Route path="/dashboard-list/*" element={<DashboardList />} />
      <Route path="/dashboard-show" element={<DashboardShows />} />

      <Route path="/gt-overlay/*" element={<GTOverlay />} />

      <Route path="/test-overlay" element={<TEST />} />

      <Route path="/event-total/*" element={<TotalOverlay />} />
      <Route
        path="/creative-total/*"
        element={<TotalOverlay eventId={174671} />}
      />
      <Route
        path="/fallout-total/*"
        element={<TotalOverlay eventId={169693} />}
      />
      <Route path="/gcx-overlay/*" element={<GCXOverlay />} />
      <Route path="/gcx-next" element={<GCXNext />} />
      <Route path="/gcx-next-small" element={<GCXNextSmall />} />
      {/* Only for prod */}
      {/* <Route exact path="/*" element={<() => {
            window.location.href= 'https://playlive.experience.stjude.org';
            return null;
        }}/> */}
    </Routes>
  );
};

export default CreateRoutes;
